<app-launch-field-container 
[basespaceFormControl]="formControl"
width="100%"
>
    <rad-button 
        (click)="openResourceMatcher()"
        [attr.disabled]="formControl.disabled"
        class="rad-theme--light resource-matcher__select-button" 
        variant="secondary">
        {{ buttonText }}
    </rad-button>

    <div class="resource-matcher__pairs-container" 
    *ngIf="!formControl.disabled" 
    [style.grid-template-columns]="'repeat(' + (formControl.value?.length || 1) + ', 1fr)'">
        <div class="resource-matcher__helper-text" *ngIf="!hasSelectedPairs">
            No pairs selected
        </div>
        
        <ng-container *ngIf="hasSelectedPairs">
            <!-- Column Headers -->
            <div *ngFor="let column of formControl.value" class="resource-matcher__column-header">
                {{ column.label }}
            </div>

            <!-- Pairs -->
            <ng-container *ngFor="let pair of pairs$ | async">
                <div *ngFor="let column of formControl.value; let columnIndex = index" class="resource-matcher__pair-cell">
                    <app-resource-chip
                        *ngIf="getResourceDisplayText(pair, columnIndex)"
                        [resourceName]="getResourceDisplayText(pair, columnIndex)"
                        [resourceUrl]="getResourceUrl(pair.columns[column.id])"
                        (chipRemoved)="removeResource(columnIndex, pair.rowIndex)">
                    </app-resource-chip>
                </div>
            </ng-container>
        </ng-container>
    </div>
</app-launch-field-container>


